<template>
  <div class="skeleton-module-package">
    <!-- header -->
    <fts-skeleton height="150px" class="skel-module-package-header" />
    <!-- content -->
    <div class="skel-module-package-content">
      <!-- alpha -->
      <div class="skel-module-package-row-alpha">
        <div class="skel-module-package-row-alpha-l">
          <fts-skeleton height="14px" width="50%" />
        </div>
        <div class="skel-module-package-row-alpha-r">   
          <fts-skeleton height="14px" />
        </div>
      </div>
      <!-- beta -->
      <div class="skel-module-package-row-beta">
        <fts-skeleton size="22px" avatar class="skel-module-emoji" />
        <fts-skeleton height="22px" width="50%" />
      </div>
      <!-- gamma -->
      <div class="skel-module-package-row-gamma">
        <fts-skeleton height="14px" />
        <fts-skeleton height="14px" width="50%" />
      </div>
      <fts-skeleton height="30px" width="80px" />
    </div>
  </div>
</template>

<script>
import FTSSkeleton from "../FTSSkeletonScreen";

export default {
  components: {
    "fts-skeleton": FTSSkeleton,
  },
}
</script>

<style lang="scss" scoped>
.skeleton-module-package {
  .skel-module-package-header {
    border-radius: 0;
  }
  .skel-module-package-content {
    padding: 1rem;
    // alpha
    .skel-module-package-row-alpha {
      display: flex;
      align-items: center;
      margin-bottom: 1.5rem;
      .skel-module-package-row-alpha-l {
        flex: 1 1 50%;;
      }
      .skel-module-package-row-alpha-r {
        flex: 1;
      }
    }
    // beta
    .skel-module-package-row-beta {
      display: flex;
      align-items: center;
      margin-bottom: .475rem;
      .skel-module-emoji {
        margin-right: .575rem;
      }
    }
    // gamma
    .skel-module-package-row-gamma {
      margin-bottom: 1.5rem;
      > *:not(:first-child) {
        margin-top: .175rem;
      }
    }
  }
}
</style>